import React, { useEffect, useState } from 'react'
import DealerModel from './models/DealerModel';

function DeleteDealer(props) {
  const [dealerData, setDealerData] = useState(new DealerModel() || []);

  useEffect(() => {
    setDealerData(props.DealerData);
  }, [props.DealerData])
  return (
    <>
      <div className="text-left px-2 pb-0">
        <p>
          <h6>Following dealer will be deleted and could not be recovered!!</h6>
          <ul>
            <li><b>Dealer :</b> {dealerData.DealerName}</li>
            <li><b>Mobile : </b>{dealerData.MobileNumber}</li>
            <li><b>Email : </b>{dealerData.EmailId}</li>
          </ul>
        </p>
      </div>
      <div id="DeleteDealerDetails" hidden>{JSON.stringify(dealerData)}</div>
    </>
  )
}

export default DeleteDealer